import axios from 'axios'
import store from '@/store'
import { provideEnvConfigOld } from 'shared/lk/helpers/env'

function bold(text) {
    return `*${text}*`
}
function red(text) {
    return '`' + text + '`'
}
function newline() {
    return '\n'
}
function makeBodyGDPRSafe(body) {
    if (!body) {
        return
    }
    return JSON.stringify(body).includes('password')
        ? 'cleaned due to GDPR. Request body contains password'
        : JSON.stringify(body)
}
function makeErrorGDPRSafe(error) {
    if (!error) {
        return 'none'
    }
    let textString = ''
    if (!error.response) {
        textString = JSON.stringify(error).includes('password')
            ? 'cleaned due to GDPR. Request body contains password'
            : JSON.stringify(error)
    } else {
        textString =
            error.response.data && error.response.data.error
                ? JSON.stringify(error.response.data.error)
                : ''
    }
    return textString
}
export function send500Error(error, channel) {
    if (!provideEnvConfigOld().is_production) {
        return
    }
    try {
        const state = store.state
        const method = error.config.method
        const url = error.config.url
        const body = error.config.data
        const msg = error.data.error.msg
        const user = state.originUser
        const jwt = state.user.jwt
        const type = state.user.type
        const href = window.location.href
        const message = `${bold(`Bad request!`)}
        ${newline()}Code: ${red(error.status)}${newline()}Method: ${red(
            method
        )}${newline()}URL: ${red(url)}${newline()}RequestBody: ${red(
            body
        )}${newline()}JTW: ${red(jwt)}${newline()}UserMail: ${red(
            user.mail
        )}${newline()}UserName: ${red(
            `${user.name}`
        )}${newline()}UserType: ${red(type)}${newline()}Message: ${red(
            msg
        )}${newline()}Localization: ${red(href)}${newline()}App: ${red('WEB')}`
        return channel == '500'
            ? sendToSlack500(message)
            : sendToSlackEmergency(message)
    } catch (error) {
        console.log(error)
    }
}
function sendToSlackEmergency(message) {
    return axios.post(getApiUrl('v1/tools/slack'), {
        url: 'https://hooks.slack.com/services/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',
        message: message,
        channel: '#emergency',
        hash: 'cdbc8192dcecfa1975739b52eb8f1141a23c68e66866b8f056159d34c4fba1ef'
    })
}
function sendToSlack500(message) {
    return axios.post(getApiUrl('v1/tools/slack'), {
        url: 'https://hooks.slack.com/services/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',
        message: message,
        channel: '#500',
        hash: 'f390487b0a8dbd64e0256f2da5040b592e1a4df03f5d8e1ca7cd60ba38898608'
    })
}
export async function unknownError777(error) {
    if (!error || !error.config) {
        return
    }
    const { method, url, data } = error.config
    const user = store.state.originUser || {}
    const errorMsg = makeErrorGDPRSafe(error)
    const jwt = store.state.user ? store.state.user.jwt : 'none'
    const message = `${bold(`Bad request!`)}
	${bold('Code:')} ${red(-777)}
	${bold('Method:')} ${red(method)}
	${bold('URL:')} ${red(url)}
	${bold('RequestBody:')} ${red(makeBodyGDPRSafe(data))}
	${bold('JTW:')} ${red(jwt)}
	${bold('UserID:')} ${red(`${user.account_id}`)}
	${bold('UserMail:')} ${red(`${user.mail}`)}
	${bold('UserName:')} ${red(`${user.name}`)}
	${bold('Message:')} ${red(`${errorMsg}`)}
	${bold('App:')} ${red('WEB')}`
    process.env.NODE_ENV == 'production'
        ? sendErrors(message)
        : sendDevErrors(message)
}
function getApiUrl(url) {
    const region = store.getters['getRegion']()
        ? store.getters['getRegion']()
        : 'pl'
    return `${process.env.VUE_APP_API_URL.replace('{region}', region).replace(
        '{env}',
        '.'
    )}${url}`
}
function sendErrors(message) {
    if (!provideEnvConfigOld().is_production) {
        return
    }
    axios
        .post(getApiUrl('v1/tools/slack'), {
            url: 'https://hooks.slack.com/services/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',
            message: message,
            channel: '#errors',
            hash: '865e22f9211901346d2c6722369b7a6b7ba02adcecf7b070a7908d75eca53016'
        })
        .catch(error => {
            console.log(error)
        })
}
function sendDevErrors(message) {
    if (process.env.NODE_ENV == 'production') {
        return
    }
    axios
        .post(getApiUrl('v1/tools/slack'), {
            url: 'https://hooks.slack.com/services/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',
            message: message,
            channel: '#dev_errors',
            hash: '07e4439f373bf9c63a853cf79da63f724afc74f55344bbe876980dd0636b3932'
        })
        .catch(error => {
            console.log(error)
        })
}

export const sendCateringRequest = ({ company, phone, email }) => {
    const { region } = store.state
    const message = `${bold(`New request!`)}${newline()}Company: ${red(
        company
    )}${newline()}Phone: ${red(phone)}${newline()}Email: ${red(
        email
    )}${newline()}Region: ${red(region)}`
    return axios.post(getApiUrl('v1/tools/slack'), {
        url: 'https://hooks.slack.com/services/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',
        message,
        channel: '#catering_request',
        hash: '39de0480f141b66c70c81627e452eb189832c91607d6ceca4039712c530d84ef'
    })
}
